import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useReducer, useCallback } from 'react'; // Constants

import { EMPTY_ARRAY } from '../../app.constants'; // Reducers

import REDUCER from './useFetchData.reducer'; // Helpers

import { fetchDataEffect } from './useFetchData.helpers';
var INITIAL_STATE = {
  data: undefined,
  isLoading: true,
  hasError: false
};
/**
 * Hook to fetch data and handling loading and error state.
 * Also caches dependencies to syncronize data and dependencies
 * @param {Promise} fetchData promise to fetch data. [Dependancy]
 * @param {Array} params parameters to pass to fetch data. [Dependancy]
 */

var useFetchData = function useFetchData(fetchData) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_ARRAY;
  var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : INITIAL_STATE;

  var _useReducer = useReducer(REDUCER, _objectSpread(_objectSpread({}, initialState), {}, {
    cachedDependencies: params
  })),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var usefetchDataEffect = useCallback(function () {
    return fetchDataEffect(dispatch, fetchData, params);
  }, params);
  useEffect(usefetchDataEffect, [usefetchDataEffect]);
  return [state, {
    fetchData: usefetchDataEffect
  }];
};

export default useFetchData;